module.exports = __webpack_public_path__ + "media/images/team/mark_wood-d84c274fb01fa108c5e4034df8151ccd.png";